module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goVideoCategories()
      }
    }
  }, [_vm._v("戻る")])])]), _c('section', {
    staticClass: "content"
  }, [_c('dl', {
    staticClass: "container"
  }, [_c('dt', [_vm._v("企業理念の唱和")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M1.mp4",
      "poster": _vm.poster('M1'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("入退室時のマナー")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M2.mp4",
      "poster": _vm.poster('M2'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("感じの良い聴き方・話し方")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M3.mp4",
      "poster": _vm.poster('M3'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("身だしなみと服装（男性）")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M4.mp4",
      "poster": _vm.poster('M4'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("身だしなみと服装（女性）")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M5.mp4",
      "poster": _vm.poster('M5'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ce465924!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/video-courtesy.pug
// module id = 1449
// module chunks = 1